import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <div className="logo-icon">
                  <span className="logo-text">SH</span>
                </div>
                <div className="logo-name">
                  <span className="logo-brand">SlotsHub</span>
                  <span className="logo-uk">UK</span>
                </div>
              </Link>
              <p className="footer-tagline">
                Your trusted guide to licensed UK online casinos. We provide honest reviews, 
                compare bonuses, and help you find the best places to play responsibly.
              </p>
              <div className="footer-social">
                <a href="#" aria-label="Twitter" className="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                </a>
                <a href="#" aria-label="Facebook" className="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/how-we-review">How We Review</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/help">Help Centre</Link></li>
              </ul>
            </div>

            <div className="footer-links">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                <li><Link to="/responsible-gambling">Responsible Gambling</Link></li>
              </ul>
            </div>

            <div className="footer-trust">
              <h4>Safe & Responsible</h4>
              <div className="trust-logos">
                <a href="https://www.gamblingcommission.gov.uk/" target="_blank" rel="noopener noreferrer" className="trust-logo">
                  <img src="/logos/ukgc.webp" alt="UK Gambling Commission" />
                </a>
                <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer" className="trust-logo">
                  <img src="/logos/gamstop.jpg" alt="GAMSTOP" />
                </a>
                <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="trust-logo">
                  <img src="/logos/begambleaware.svg" alt="BeGambleAware" />
                </a>
                <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="trust-logo">
                  <img src="/logos/gamcare.svg" alt="GamCare" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-disclaimer">
        <div className="container">
          <div className="disclaimer-content">
            <div className="age-warning">
              <span className="age-badge-large">18+</span>
              <p>Gambling is for adults only. You must be 18 years or older to gamble.</p>
            </div>
            <p className="disclaimer-text">
              SlotsHub UK is an affiliate website. We may receive commission from the casinos featured on our site. 
              This does not affect our reviews, which are based on honest assessments of each operator. 
              All casinos listed are licensed by the UK Gambling Commission. Gambling can be addictive. 
              Please play responsibly and only bet what you can afford to lose. 
              If you're concerned about your gambling, visit <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer">GambleAware.org</a> or 
              call the National Gambling Helpline on <strong>0808 8020 133</strong>.
            </p>
            <p className="copyright">
              © {new Date().getFullYear()} SlotsHub UK. All rights reserved. | Gamble Responsibly.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
